import { createSlice } from "@reduxjs/toolkit";
const userItemsFromStorage = JSON.parse(localStorage.getItem("persist:root"))
	? JSON.parse(localStorage.getItem("persist:root"))?.userRegister
	: {};
console.log(userItemsFromStorage);
const userRegisterSlice = createSlice({
	name: "user",
	initialState: userItemsFromStorage,
	reducers: {
		registerStart: (state) => {
			state.loading = true;
		},
		registerSuccess: (state, action) => {
			state.loading = false;
			state.userInfo = action.payload;
			state.error = false;
			state.success = true;
		},
		registerFailure: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
		registerReset: (state, action) => {
			state.error = false;
			state.success = false;
		},
	},
});

export const { registerStart, registerSuccess, registerFailure,registerReset } =
	userRegisterSlice.actions;
export default userRegisterSlice.reducer;
